<template>

    <div class="main-content">
        <h4>User Maintenance: Edit</h4>
        <p class="diagonal-lines"></p>
        <success v-if="success" class="my-2">
            User data has been updated.
        </success>
        <div class="row mt-3">
            <div class="col-sm-6" v-if="editUser">
                <form class="mb-5">
                    <div class="form-group">
                        <label for="name">First Name:</label>
                        <input type="text" name="f_name" class="form-control" v-model="editUser.f_name" :class="[{'is-invalid':errorFor('f_name')}]">
                        <v-errors :errors="errorFor('f_name')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="name">Last Name:</label>
                        <input type="text" name="l_name" class="form-control" v-model="editUser.l_name" :class="[{'is-invalid':errorFor('l_name')}]">
                        <v-errors :errors="errorFor('l_name')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="company">Company:</label>
                        <input type="text" name="company" class="form-control" v-model="editUser.company" :class="[{'is-invalid':errorFor('company')}]">
                        <v-errors :errors="errorFor('company')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="title">Title:</label>
                        <input type="text" name="title" class="form-control" v-model="editUser.title" :class="[{'is-invalid':errorFor('title')}]">
                        <v-errors :errors="errorFor('title')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="user_group">User Group:</label>
                        <admin-select name="user_group" v-model="editUser.user_group_id" class="form-select">
                            <option v-for="(group,index) in userGroup" :key="index" :value=group.id :selected="group.id==editUser.user_group_id">{{ group.user_group }}</option>
                        </admin-select>

                    </div>
                    <div class="form-group" v-if="editUser.user_group_id=='3'">
                        <label for="address">CUSTOMER BILL-TO:</label>
                        <input type="text" name="custID" class="form-control" v-model="editUser.cust_id" >

                    </div>
                    <div class="form-group">
                        <label for="address">Address:</label>
                        <input type="text" name="add1" class="form-control" v-model="editUser.add1" :class="[{'is-invalid':errorFor('add1')}]">
                        <v-errors :errors="errorFor('add1')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="address2">Address Line 2:</label>
                        <input type="text" name="add2" class="form-control" v-model="editUser.add2" :class="[{'is-invalid':errorFor('add2')}]">
                        <v-errors :errors="errorFor('add2')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="city">City:</label>
                        <input type="text" name="city" class="form-control" v-model="editUser.city" :class="[{'is-invalid':errorFor('city')}]">
                        <v-errors :errors="errorFor('city')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="state">State:</label>
                        <input type="text" name="state" class="form-control" v-model="editUser.state" :class="[{'is-invalid':errorFor('state')}]">
                        <v-errors :errors="errorFor('state')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="zipcode">Zipcode:</label>
                        <input type="text" name="zip" class="form-control" v-model="editUser.zip" :class="[{'is-invalid':errorFor('zip')}]">
                        <v-errors :errors="errorFor('zip')"></v-errors>
                    </div>
                    <div class="form-group">
                        <label for="email">Email Address:</label>
                        <input type="email" name="email" class="form-control" v-model="editUser.email" :class="[{'is-invalid':errorFor('editUser.email')}]" disabled>
                        <small class="form-text text-muted">Email is not editable.</small>
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone Number:</label>
                        <input type="text" name="phone" class="form-control" v-model="editUser.phone" :class="[{'is-invalid':errorFor('phone')}]">
                        <v-errors :errors="errorFor('phone')"></v-errors>
                    </div>
                    <div class="d-flex justify-content-between">
                        <button  class="btn-round-green pt9rem mr-3" :disabled="loading" @click.prevent="updateUser">SAVE</button>
                        <router-link  class="btn-round-red pt9rem " :to="{name:'changeUserPassword', params:{id:editUser.id}}" >CHANGE PASSWORD</router-link>
                    </div>

                </form>

            </div>
        </div>


    </div>


</template>
<style lang="scss" scoped>
    select{
        display: block;
        width:100%;
        padding: 0.375rem 0.75rem;
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        text-transform: capitalize;
    }
    label{
        margin-bottom: 0;
        font-weight: 600;
        text-transform: uppercase;
    }
</style>
<script>
import validationErrors from '../mixins/validationErrors';
import {mapState, mapGetters} from  "vuex";
    export default{
        mixins: [validationErrors],
        data(){
            return{
                loading:false,
                success:false,
                editUser:{},
                userGroup:[],
                error:null
            };
        },
         computed:{

         },
         created(){
            this.loading=true;
            axios.get(`/api/user/${this.$route.params.id}`)
                .then(response=> {
                    this.editUser=response.data;
                    this.loading=false;
                });


        },
        mounted() {
            // get user group
            axios.get(`/api/usergroup`)
            .then(response => {
                this.userGroup = response.data;
            });
        },
        methods:{
            async updateUser(){
                this.loading=true;
                this.error=null;
                try {
                    await axios.post(`/api/userUpdate`, this.editUser).then((response) => {
                        window.scrollTo(0,0);
                        this.loading=false;
                        this.success=true;
                        var self=this;
                        setTimeout(function(){
                            self.success=false;
                        }, 4000);
                    });
                    // this.$store.dispatch("loadUser");
                } catch (error) {
                     this.error=error.response && error.response.data.errors;

                }

            },

        },
    };
</script>
